import React, {useEffect, useState} from "react";
import {doc, getDoc} from "firebase/firestore";
import {db} from "../../index";
import {useNavigate, useParams} from "react-router-dom";
import globalMasehtot from "../masehtot.json";
import ConfettiComponent from "../userStatus/confetti";
import SiumProgress from "../niulSium/siumStatus/siumProgress";
import Spinner from "../../spinner";

const SiumDapimStatus = () => {

    const params = useParams();
    const [sium, setSium] = useState([]);
    const [displaySium, setDisplaySium] = useState([]);
    const [siumPages, setSiumPages] = React.useState();
    const [pagesWereTaken, setPagesWereTaken] = React.useState(0);
    const [pagesWereLearned, setPagesWereLearned] = React.useState(0);
    const [filterStillFree, setFilterStillFree] = React.useState(false);
    const [filterNotLearnedYet, setFilterNotLearnedYet] = React.useState(false);
    const navigate = useNavigate();

    function handleSiumPages(displaySium, siumObj, pagesWereTaken, showStillFree = false, showNotLearnedYet = false) {
        if (!displaySium) return;
        let siumExtraTaken = 0;
        const pagesNames = globalMasehtot.onlyPages;
        const masehtotList = Object.entries(displaySium.displayPagesList)
            .sort(([, a], [, b]) => a.masehetIndex - b.masehetIndex)
            .filter(([masehetKey, masehetPages]) => {
                const totalPages = masehetPages["totalPages"];
                const learnedPages = masehetPages["learnedPages"].length;
                const takenPages = masehetPages["takenPages"].length;

                const allTaken = (takenPages + learnedPages) === totalPages;
                const allLearned = learnedPages === totalPages;

                if (!showStillFree && !showNotLearnedYet) return true;
                if (showStillFree && allTaken) return false;
                if (showNotLearnedYet && allLearned) return false;

                return true;
            })
            .map(([masehetKey, masehetPages]) => {

            const currentMasehet = globalMasehtot.allMasehtot[masehetKey];
            const siumMasehetStatus = siumObj.masehtotSelection.filter(obj => Object.keys(obj)[0] === masehetKey).flatMap(obj => obj[masehetKey]);
            const totalPages = masehetPages["totalPages"];
            const learnedPages = masehetPages["learnedPages"].length;
            let takenPages = masehetPages["takenPages"].length;
            const startIndex = !currentMasehet.canByChoose ? 0 :
                globalMasehtot.onlyPages.indexOf((currentMasehet.chapters[0].startPage).replace(/[.:]/g, ""))
            const pagesForMasehet = [];

            for (let p_index = 0; p_index < totalPages; p_index++) {
                const pageName = currentMasehet.isMishna? globalMasehtot.allChapters[p_index] : pagesNames[startIndex + p_index];
                const pageId = `${masehetKey}-${p_index}`;
                const wasLearned = masehetPages["learnedPages"].includes(p_index.toString());
                let wasTaken = masehetPages["takenPages"].includes(p_index.toString()) || wasLearned;
                if (!wasTaken && siumMasehetStatus && siumMasehetStatus.length > 0 && siumMasehetStatus.length > p_index && siumMasehetStatus[p_index]) {
                    wasTaken = true;
                    takenPages++;
                    siumExtraTaken++;
                }

                pagesForMasehet.push(<>
                    {wasLearned && <button type="button" id={pageId}
                        className={`btn btn-primary status-taken-button ${currentMasehet.isMishna ? "mishna-button" : "daf-button"}`}>{pageName}</button>}
                    {!wasLearned && wasTaken && <button type="button" id={pageId}
                        className={`btn btn-info  status-taken-button ${currentMasehet.isMishna ? "mishna-button" : "daf-button"}`}>{pageName}</button>}
                    {!wasLearned && !wasTaken && <button type="button" id={pageId}
                        className={`btn btn-outline-secondary ${currentMasehet.isMishna ? "mishna-button" : "daf-button"}`}>{pageName}</button>}
                </>);
            }

            const allTaken = totalPages === takenPages + learnedPages;
            const allLearned = totalPages === learnedPages;

            return (
                <div className="accordion-item" key={masehetKey + "-takenMasehet"}>
                    <h3 className="accordion-header">
                        <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                data-bs-target={"#collapseTaken" + masehetKey} aria-expanded="false" aria-controls={"collapseTaken" + masehetKey}>
                            <span className="masehet-title">{currentMasehet.name}</span>
                            {currentMasehet.isMishna && <span className="badge bg-success margin-right-10">משנה</span>}
                            {!allTaken && <span className="badge bg-info margin-right-10">{totalPages} / {takenPages+learnedPages} נלקחו</span>}
                            {allTaken && <span className="badge bg-info margin-right-10">המסכת נתפסה</span>}
                            {!allLearned && !allTaken && <span className="badge bg-primary margin-right-10">{learnedPages} נלמדו</span>}
                            {!allLearned && allTaken && <span className="badge bg-primary margin-right-10">{totalPages} / {learnedPages} נלמדו</span>}
                            {allLearned && <span className="badge bg-primary margin-right-10">הדרן עלך</span>}
                        </button>
                    </h3>
                    <div id={"collapseTaken" + masehetKey} className="accordion-collapse collapse" data-bs-parent="#shasStatusList">
                        <div className="accordion-body">
                            <div id={masehetKey + "Dapim"}>
                                {pagesForMasehet}
                            </div>
                        </div>
                    </div>
                </div>
            );
        });
        setPagesWereTaken(pagesWereTaken + siumExtraTaken);
        return masehtotList;
    }

    function shareLomdimLoginPage() {
        if (navigator.share) {
            navigator.share({
                title: 'סיום הש"ס של "' + sium.kehilaName + '"',
                text: 'סיום הש"ס של "' + sium.kehilaName + '" - כניסה ללומדים',
                url: '/lomdimLogin/' + sium.id
            });
        }
    }

    // Handle masehtot filter changes
    const handleMasehtotFilterChange = (filterType, value) => {
        let newFilterStillFree = filterStillFree;
        let newFilterNotLearnedYet = filterNotLearnedYet;

        if (filterType === 'stillFree') {
            newFilterStillFree = value;
            setFilterStillFree(value);
        } else if (filterType === 'notLearnedYet') {
            newFilterNotLearnedYet = value;
            setFilterNotLearnedYet(value);
        }

        setSiumPages(handleSiumPages(displaySium, sium, pagesWereTaken, newFilterStillFree, newFilterNotLearnedYet));
    };

    useEffect(() => {

        const fetchDisplay = async () => {
            const docRef = doc(db, "displaySium", params.displayId);
            getDoc(docRef).then(displaySium => {
                if (displaySium && displaySium.exists()) {
                    setDisplaySium(displaySium.data());
                    const docRef = doc(db, "siumim", displaySium.data().siumId);
                    getDoc(docRef).then(sium => {
                        setSium({ ...sium.data(), id: sium.id });
                        let pagesWereLeanred = 0;
                        let pagesWereTaken = 0;

                        if (!displaySium.data().displayPagesList) {
                            navigate("/");
                        }

                        Object.values(displaySium.data().displayPagesList).map((masehet) => {
                            pagesWereLeanred += masehet.learnedPages.length;
                            pagesWereTaken += masehet.takenPages.length;
                            return;
                        });
                        pagesWereTaken += pagesWereLeanred;

                        setSiumPages(handleSiumPages(displaySium.data(), sium.data(), pagesWereTaken));
                        setPagesWereLearned(pagesWereLeanred);
                    });
                } else {
                    navigate("/");
                }
            });
        }

        fetchDisplay();
    },[params.displayId]);


    if (sium && sium.kehilaName && globalMasehtot.allMasehtot) {
        return(
            <div className="sium-main">
                <div className="sium-main-container">
                    <div className="sium-main-header">
                        <div className="basad">
                            <span>בס"ד</span>
                            <br/>
                            <span>להצלחת עם ישראל</span>
                        </div>
                    </div>
                    <div className="sium-logo">
                        <a className="sium-logo-img" href="/" aria-label="Home page" role="link"></a>
                    </div>
                    <div className="grid p-3 text-primary-emphasis bg-primary-subtle border border-primary-subtle rounded-3 sium-titles">
                        {sium.nishmat && <span>הלימוד {sium.nishmat}</span>}
                        <h2>סיום הש"ס של {sium.kehilaName}</h2>
                        {sium.logo && <div alt="logo" className={sium.logo}/>}
                    </div>
                    <div id="displayMasehtot" className="sium-status-options-container">
                        {pagesWereTaken < sium.pagesCounter && <div>
                            <div className="sium-status-option" onClick={() => window.location = "/addUser/" + displaySium.siumId} tabIndex={0}>
                                <svg fill="#414a87" height="200px" width="200px" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 511.999 511.999"><g id="SVGRepo_bgCarrier" strokeWidth="0"></g><g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g><g id="SVGRepo_iconCarrier"> <g> <g> <path d="M503.292,210.719H398.127l-2.721-33.724c-0.005-0.053-0.015-0.104-0.021-0.157c-0.003-0.031-0.007-0.062-0.01-0.092 l-8.003-99.08c-0.365-4.522-4.141-8.007-8.68-8.007H133.303c-4.537,0-8.314,3.484-8.68,8.007l-2.457,30.415 c-0.387,4.794,3.185,8.994,7.979,9.381c4.807,0.389,8.993-3.185,9.381-7.979l1.81-22.408h229.323l6.617,81.912h-16.777 c-4.81,0-8.708,3.899-8.708,8.708s3.898,8.708,8.708,8.708h18.195l1.962,24.312H131.344l1.966-24.312h198.163 c4.81,0,8.708-3.899,8.708-8.708s-3.898-8.708-8.708-8.708H134.718l2.356-29.139c0.387-4.794-3.185-8.994-7.979-9.381 c-4.803-0.385-8.994,3.186-9.381,7.979l-5.845,72.273H8.708c-4.809,0-8.708,3.899-8.708,8.708s3.899,8.708,8.708,8.708h101.747 c-1.457,1.996-3.484,3.93-6.064,6.31c-6.083,5.611-14.414,13.295-14.414,27.819c0,14.525,8.331,22.209,14.414,27.82 c5.787,5.339,8.807,8.43,8.807,15.019c0,6.588-3.02,9.68-8.807,15.018c-6.083,5.611-14.414,13.295-14.414,27.82 s8.331,22.21,14.414,27.822c5.787,5.339,8.807,8.432,8.807,15.022c0,6.59-3.02,9.683-8.807,15.022 c-6.083,5.611-14.414,13.298-14.414,27.822c0,4.809,3.899,8.708,8.708,8.708s8.708-3.899,8.708-8.708 c0-6.59,3.02-9.682,8.807-15.022c6.083-5.611,14.414-13.297,14.414-27.822c0-14.525-8.331-22.211-14.414-27.822 c-5.787-5.339-8.807-8.432-8.807-15.022c0-6.588,3.02-9.681,8.807-15.019c6.084-5.611,14.414-13.295,14.414-27.819 c0-14.525-8.331-22.209-14.414-27.82c-5.787-5.339-8.807-8.43-8.807-15.019c0-6.588,3.02-9.68,8.807-15.018 c4.73-4.363,10.804-9.998,13.278-19.111h253.047c2.474,9.113,8.548,14.748,13.278,19.111c5.787,5.339,8.807,8.43,8.807,15.018 c0,6.589-3.02,9.681-8.807,15.019c-6.083,5.611-14.414,13.296-14.414,27.82s8.332,22.209,14.414,27.819 c5.787,5.339,8.807,8.43,8.807,15.019c0,6.59-3.02,9.682-8.807,15.022c-6.083,5.611-14.414,13.298-14.414,27.822 c0,14.525,8.332,22.211,14.414,27.822c5.787,5.339,8.807,8.432,8.807,15.022c0,4.809,3.898,8.708,8.708,8.708 c4.81,0,8.708-3.899,8.708-8.708c0-14.525-8.331-22.21-14.413-27.822c-5.788-5.339-8.808-8.432-8.808-15.022 c0-6.59,3.02-9.683,8.808-15.022c6.083-5.611,14.413-13.298,14.413-27.822s-8.332-22.209-14.414-27.82 c-5.787-5.339-8.807-8.43-8.807-15.018c0-6.589,3.02-9.681,8.807-15.019c6.083-5.611,14.414-13.296,14.414-27.82 c0-14.524-8.332-22.209-14.414-27.819c-2.58-2.38-4.607-4.315-6.064-6.31h101.747c4.81,0,8.708-3.899,8.708-8.708 S508.102,210.719,503.292,210.719z"></path> </g> </g> </g></svg>
                                <span>הוסף לומד</span>
                            </div>
                        </div>}
                        <div id="shasStatus">
                            <div className="card card-body">
                                <SiumProgress dapim={true} takenPages={Math.floor((pagesWereTaken/sium.pagesCounter) * 100)}
                                    learnedPages={Math.floor((pagesWereLearned/sium.pagesCounter) * 100)}/>

                                {/* Filter checkboxes */}
                                <div className="masehtot-filter-container margin-top-10 margin-bottom-10">
                                    <label className="masehtot-filter-label">סינון:</label>
                                    <div className="form-check form-check-inline">
                                        <input
                                            className="form-check-input"
                                            type="checkbox"
                                            id="filterStillFreeDapim"
                                            checked={filterStillFree}
                                            onChange={(e) => handleMasehtotFilterChange('stillFree', e.target.checked)}
                                        />
                                        <label className="form-check-label" htmlFor="filterStillFreeDapim">
                                            פנויות
                                        </label>
                                    </div>
                                    <div className="form-check form-check-inline">
                                        <input
                                            className="form-check-input"
                                            type="checkbox"
                                            id="filterNotLearnedYetDapim"
                                            checked={filterNotLearnedYet}
                                            onChange={(e) => handleMasehtotFilterChange('notLearnedYet', e.target.checked)}
                                        />
                                        <label className="form-check-label" htmlFor="filterNotLearnedYetDapim">
                                            לא נלמדו
                                        </label>
                                    </div>
                                </div>

                                <button className="btn dark-button share-display-sium" onClick={() => shareLomdimLoginPage()}>
                                    לינק כניסה ללומדים
                                </button>
                                <div className="accordion" id="shasStatusList">
                                    {siumPages}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="sium-bottom-page">
                        <span> © כל הזכויות שמורות לאתר סיום הש"ס</span>
                    </div>
                </div>
                {pagesWereLearned === sium.pagesCounter && <ConfettiComponent></ConfettiComponent>}
            </div>
        )
    } else {
        return (<Spinner/>);
    }

}

export default SiumDapimStatus;
